/** Thai strings for daily quests (English source text -> Thai). */
export const DAILY: Record<string, string> = {
  "Today's Quests": 'ภารกิจวันนี้',
  "Today's Quests:": 'ภารกิจวันนี้:',
  'New quests every day. Finish all three for a bonus.': 'มีภารกิจใหม่ทุกวัน ทำครบ 3 ข้อรับโบนัส',
  'Bonus for all three: +{coins} coins': 'ทำครบ 3 ข้อได้โบนัส +{coins} เหรียญ',
  'All done today! Come back tomorrow for new quests.': 'วันนี้ทำครบแล้ว! พรุ่งนี้มาเจอภารกิจใหม่นะ',
  '{n}-day streak': 'ทำต่อเนื่อง {n} วัน',
  'Start a streak today!': 'เริ่มทำต่อเนื่องวันนี้เลย!',
  '(max bonus)': '(โบนัสสูงสุด)',
  'All done for today! +{coins} bonus coins · {n}-day streak': 'วันนี้ทำครบแล้ว! โบนัส +{coins} เหรียญ · ต่อเนื่อง {n} วัน',
  'All daily quests done!': 'ทำภารกิจรายวันครบแล้ว!',
  '+{coins} bonus coins. Streak: {n} days.': 'โบนัส +{coins} เหรียญ ทำต่อเนื่อง {n} วัน',
  'Daily quest done: {quest}': 'ภารกิจวันนี้สำเร็จ: {quest}',

  // Quests (data/daily.ts)
  'Recess Champion': 'แชมป์พักเที่ยง',
  'Win 3 battles today.': 'ชนะ 3 ครั้งวันนี้',
  'Busy Playground': 'สนามเด็กเล่นคึกคัก',
  'Fight 4 battles today.': 'สู้ 4 ครั้งวันนี้',
  'Gold Star Day': 'วันดาวทอง',
  'Win a story battle with 3 stars.': 'ชนะด่านเนื้อเรื่องแบบได้ 3 ดาว',
  'Beat a Champion': 'ล้มแชมป์',
  'Boss Raid': 'บุกตีบอส',
  'Fight the boss of the week once.': 'สู้กับบอสประจำสัปดาห์ 1 ครั้ง',
  'Dare Accepted': 'รับคำท้า',
  'Beat a monster a friend dared you with.': 'ชนะมอนสเตอร์ที่เพื่อนส่งมาท้า',
  'Pass the Notebook': 'ส่งสมุดให้เพื่อน',
  'Send a friend a monster to beat.': 'ส่งมอนสเตอร์ไปท้าเพื่อน 1 ตัว',
  'Fan Mail': 'จดหมายจากแฟนคลับ',
  'Send a sticker to the artist of a monster you fought.': 'ส่งสติกเกอร์ให้คนวาดมอนสเตอร์ที่เราสู้ด้วย',
  'Defeat a Hall of Fame monster.': 'ชนะมอนสเตอร์ในหอเกียรติยศ',
  'Rock Practice': 'ฝึกค้อน',
  'Win 4 rounds with Rock today.': 'ชนะด้วยค้อน 4 ตาวันนี้',
  'Paper Practice': 'ฝึกกระดาษ',
  'Win 4 rounds with Paper today.': 'ชนะด้วยกระดาษ 4 ตาวันนี้',
  'Scissors Practice': 'ฝึกกรรไกร',
  'Win 4 rounds with Scissors today.': 'ชนะด้วยกรรไกร 4 ตาวันนี้',
  'Doodle of the Day': 'รูปวาดประจำวัน',
  'Draw and save a new monster.': 'วาดและบันทึกมอนสเตอร์ตัวใหม่',
  'Contest Judge': 'กรรมการประกวด',
  'Vote for a monster in the contest.': 'โหวตมอนสเตอร์ในการประกวด',
  'Show and Tell Day': 'วันอวดผลงาน',
  'Battle a Classmate': 'ดวลกับเพื่อนร่วมห้อง',
  'Play one online battle.': 'เล่นสู้ออนไลน์ 1 ครั้ง',
};
